import React from 'react';
import ProductListSlider from '../productListSlider';
import { useSelector, shallowEqual } from 'react-redux';

import styles from './ProductWidget.module.scss';
import { getTags } from '@srcDS/utils/helpers';

const CompleteTheOutfit = (props) => {
  const {
    mdSlidesPerView = 2.2,
    lgSlidesPerView = 2.8,
    smSlidesPerView = 1.5,
    xlSlidesPerView = 2.5,
    products,
    smOffsets = 0,
    mdOffsets,
    lgOffsets,
    xlOffsets,
    title,
    label,
    showArrows = false,
  } = props;
  const { wishlist, locale } = useSelector(
    (state) => ({
      wishlist: state.wishlist,
      locale: state.app.context.locale,
    }),
    shallowEqual,
  );

  const formattedProducts = products?.map((product) => {
    return {
      ...product,
      projectSpecificData: {
        ...product.projectSpecificData,
        prices: product.variants[0]?.projectSpecificData?.prices,
        discount: product.variants[0]?.projectSpecificData?.discount,
      },
      tags: getTags(product?.variants[0], product),
    };
  });

  const getText = (text) => {
    if (!text) return '';
    if (typeof text === 'object') {
      return text[locale] || '';
    }

    return text;
  };

  return (
    <ProductListSlider
      placement="productOutfit"
      smSlidesPerView={smSlidesPerView}
      mdSlidesPerView={mdSlidesPerView}
      lgSlidesPerView={lgSlidesPerView}
      xlSlidesPerView={xlSlidesPerView}
      smOffsets={smOffsets}
      mdOffsets={mdOffsets}
      lgOffsets={lgOffsets}
      xlOffsets={xlOffsets}
      products={formattedProducts}
      title={getText(title)}
      label={getText(label)}
      titleAlign="center"
      wishlist={wishlist}
      centerInsufficientSlides
      type="completeOutfit"
      scrollBarVisibility="always"
      scrollbarEl="products-swiper-scrollbar"
      listName={getText(title)}
      swiperWithArrows={showArrows}
      enableTouchOnMobile={false}
      customClasses={{
        centerMode: styles.centerMode,
        customScrollbar: styles.scrollbar,
      }}
    />
  );
};

export default CompleteTheOutfit;
